export default __webpack_public_path__ + "static/media/image-next.0042d0e3.svg";